module.exports = __webpack_public_path__ + "img/20191031163157360截图20191031152210281.8b529ec1.jpg";